import type { BreadcrumbsProps } from "./types";

import { Breadcrumbs } from "@digdir/designsystemet-react";

export type { BreadcrumbsProps };

const EventBreadcrumbsBlock = (props: BreadcrumbsProps) => {
    const crumbs = props.items;
    if (!crumbs?.length) return null;

    return (
        <Breadcrumbs
            aria-label="Du er her:"
            data-color={"neutral"}
            data-size="sm"
            className="content flex py-2.5 lg:pb-8 md:pt-3 xl:pt-[13px] xl:pb-[41px]"
        >
            {crumbs.length > 1 && (
                <Breadcrumbs.Link
                    aria-label={`Tilbake til ${crumbs[0].title}`}
                    href={crumbs[0].url}
                    className="text-md"
                >
                    {crumbs[0].title}
                </Breadcrumbs.Link>
            )}
            <Breadcrumbs.List>
                {crumbs.map((item) => {
                    return (
                        <Breadcrumbs.Item key={item.url}>
                            <Breadcrumbs.Link href={item.url} className="text-md text-neutral">
                                {item.title}
                            </Breadcrumbs.Link>
                        </Breadcrumbs.Item>
                    );
                })}
            </Breadcrumbs.List>
        </Breadcrumbs>
    );
};

export default EventBreadcrumbsBlock;
